export default __webpack_public_path__ + "static/media/Pilz-Button-Stehen-Lassen.30618d32.png";